import { AnySchema } from 'yup'
import { set, get } from 'lodash-es'

export function makeValidate<T>(validator: AnySchema<T>) {
  return async (values: T) => {
    try {
      await validator.validate(values, { abortEarly: false })
    } catch (err) {
      return err.inner.reduce((errors: any, { path, message }: any) => {
        if (errors.hasOwnProperty(path)) {
          set(errors, path, get(errors, path) + ' ' + message)
        } else {
          set(errors, path, message)
        }
        //console.log('errors :', errors)
        return errors
      }, {})
    }
  }
}
export function makeRequired<T>(schema: AnySchema<T>) {
  const fields = (schema as any).fields
  return Object.keys(fields).reduce((accu, field) => {
    accu[field] = fields[field].exclusiveTests?.required
    return accu
  }, {} as any)
}
